var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qianming"},[_c('div',{staticClass:"tip"},[_vm._v("（说明：请结合临床，如与医师建议有冲突，请谨遵医嘱）")]),_c('div',{staticClass:"cell"},[_vm._v("医生签名：")]),(_vm.time)?_c('div',{staticClass:"cell"},[_vm._v("日  期：")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }